import React from 'react'

interface ProjectsProps {
  isSelected?: boolean
}

export const ProjectsIcon: React.FC<ProjectsProps> = ({ isSelected = false }) => {
  const stroke = isSelected ? '#FF4A8E' : '#62718D'
  const className = isSelected ? 'dark:stroke-[#FF4A8E]' : 'dark:stroke-gray-400'

  return (
    <svg width="20" height="20" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M2 3H17.9994V14.25C17.9994 14.4489 17.9228 14.6397 17.7864 14.7803C17.65 14.921 17.465 15 17.2721 15H13.6359C13.443 15 13.2581 14.921 13.1217 14.7803C12.9853 14.6397 12.9087 14.4489 12.9087 14.25V12H7.09071V17.25C7.09071 17.4489 7.01409 17.6397 6.8777 17.7803C6.74132 17.921 6.55634 18 6.36346 18H2.72724C2.53437 18 2.34939 17.921 2.213 17.7803C2.07662 17.6397 2 17.4489 2 17.25V3Z"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        className={className}
      />
      <path
        d="M7.09071 9H2"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        className={className}
      />
      <path
        d="M7.08984 3V12"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        className={className}
      />
      <path
        d="M12.9102 9H18.0009"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        className={className}
      />
      <path
        d="M12.9102 3V12"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        className={className}
      />
    </svg>
  )
}

export default ProjectsIcon
